import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Icon, Button, Spin, Alert } from 'antd';
import Layouts from '../../components/Layouts';
import apiRequest from '../../hooks/ApiRequest';

const SubscribeSuccess = () => {
  const [loading, setLoading] = useState(true);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const checkSubscription = async () => {
      const params = new URLSearchParams(window.location.search);
      const subscription_id = params.get('subscription_id');

      if (!subscription_id) {
        setError('Subscription ID is missing in the URL.');
        setLoading(false);
        return;
      }

      try {
        const payload = {
          subscriptionId: subscription_id || ''
        };
        const res = await apiRequest(
          process.env.REACT_APP_BASE_URL + '/api/PaypalWebhook/verify-subscription',
          'POST', payload
        );

        if (res?.success && res?.data?.status === 'ACTIVE') {
          setIsSubscribed(true);
        } else {
          setError('Subscription is not active or failed.');
        }
      } catch (err) {
        setError('An error occurred while checking the subscription.');
      } finally {
        setLoading(false);
      }
    };

    checkSubscription();
  }, []);

  if (loading) {
    return (
      <Layouts title="Checking Subscription" classname="dashboard">
        <div className="dash-bg-white">
          <Spin size="large" tip="Verifying subscription..." />
        </div>
      </Layouts>
    );
  }

  if (error) {
    return (
      <Layouts title="Subscription Failed" classname="dashboard">
        <div className="dash-bg-white">
          <Alert message="Error" description={error} type="error" showIcon />
          <Button type="primary" style={{ marginTop: 24 }} href="/dashboard">
            Go to Dashboard
          </Button>
        </div>
      </Layouts>
    );
  }

  return (
    <Layouts title="Subscription Successful" classname="dashboard">
      <div className="dash-bg-white">
        <Row gutter={16}>
          <Col xs={24} sm={24} md={12}>
            <h3 style={{ color: '#0C1362', fontWeight: 600, fontSize: 20 }}>
              Payment Subscription Confirmation
            </h3>
          </Col>
        </Row>
      </div>

      <div className="dash-bg-white">
        <Card
          bordered={false}
          title={
            <span style={{ fontSize: '20px', fontWeight: '600', color: '#0C1362' }}>
              Subscription Successful
            </span>
          }
        >
          <Row justify="center" align="middle" type="flex" style={{ textAlign: 'center' }}>
            <Col span={24}>
              <Icon type="check-circle" style={{ fontSize: 48, color: '#52c41a', marginBottom: 16 }} />
              <p style={{ fontSize: 16 }}>
                Your automatic monthly payment setup has been completed successfully via PayPal.
              </p>
              <p style={{ fontSize: 16 }}>
                You will now be charged automatically every month for your policy without manual intervention.
              </p>
              <Button type="primary" style={{ marginTop: 24 }} href="/dashboard">
                Go to Dashboard
              </Button>
            </Col>
          </Row>
        </Card>
      </div>
    </Layouts>
  );
};

export default SubscribeSuccess;
